import { atomWithReset } from "jotai/utils";

export const gridAtom = atomWithReset({});
